// extracted by mini-css-extract-plugin
export default {"tags":"yxFeHR5LYRGA2MSBkvPn"};